import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from "react";
const tidalSandboxContext = createContext({
  disableKeybindings: false,
  fullScreen: false,
  globalControlsConfig: {},
  globalControlsDisabled: false,
  navigationCollapsed: false,
  navigationDisabled: false,
  navigationWidth: 0,
  sidebarPosition: "row-reverse"
});
const tidalSandboxApiContext = createContext({
  setActiveStory: () => {
  },
  setDisableKeybindings: () => {
  },
  setFullScreen: () => {
  },
  setGlobalControlsConfig: () => {
  },
  setGlobalControlsDisabled: () => {
  },
  setNavigationCollapsed: () => {
  },
  setNavigationDisabled: () => {
  },
  setNavigationWidth: () => {
  },
  setSidebarPosition: () => {
  },
  updateGlobalControlsConfig: () => {
  }
});
function TidalSandboxProvider(props) {
  const { children, tidalSandbox, tidalSandboxApi } = props;
  return /* @__PURE__ */ jsx(tidalSandboxApiContext.Provider, { value: tidalSandboxApi, children: /* @__PURE__ */ jsx(tidalSandboxContext.Provider, { value: tidalSandbox, children }) });
}
function useTidalSandbox() {
  return useContext(tidalSandboxContext);
}
function useTidalSandboxApi() {
  return useContext(tidalSandboxApiContext);
}
function useUpdateTidalSandboxGlobalConfigOnce(panel, value) {
  const { updateGlobalControlsConfig, setGlobalControlsConfig } = useTidalSandboxApi();
  useEffect(() => {
    let valueToRestore = {};
    updateGlobalControlsConfig((prev) => {
      valueToRestore = prev?.[panel] ?? {};
      return { [panel]: { ...prev?.[panel], ...value } };
    });
    return () => {
      setGlobalControlsConfig((prev) => ({
        ...prev,
        [panel]: { ...valueToRestore }
      }));
    };
  }, []);
}
export {
  TidalSandboxProvider,
  useTidalSandbox,
  useTidalSandboxApi,
  useUpdateTidalSandboxGlobalConfigOnce
};
//# sourceMappingURL=TidalSandboxProvider.js.map
